/**
 * @author WYX
 * @date 2019/12/26
 * @Description: 稿件发稿单指令模块
 */
angular.module('editPageMusendModule', []).directive('editPageMusend', [
    'iWoService',
    'messagePublishService',
    function(iWoService, messagePublishService) {
        return {
            scope: true, // 继承作用域
            restrict: 'EA',
            templateUrl: './editingCenter/directive/editPagePart/editPageMusend/editPageMusend.html',
            replace: true,
            link: function($scope) {
                initStatus();
                initData();

                /**
                 * [initStatus description]初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    $scope.data = {
                        docgenre: '',
                    };
                }

                /**
                 * [initData description]初始化数据
                 *
                 * @return  {[type]}  [return description]
                 */
                function initData() {
                    var draftList =
                        '<editor-dir list="list"  meta-data-id="{{list.METADATAID}}" editor-json="list.FGD_EDITINFO" editor-form="[parentData.formName]"></editor-dir>' +
                        '<editor-auth-dir author="list.FGD_AUTHINFO" originalchildtype="list.ORIGINAL==1&&data.originType==3?1:0"></editor-auth-dir>';
                    draftList = $scope.compile(draftList)($scope);
                    $scope.element.find('editor').append(draftList);
                    if ($scope.parentStatus.articleid){
                        messagePublishService.subscribe(
                            `${$scope.parentStatus.mediaName}ListInit`,
                            function() {
                                initDocgenre($scope.list);
                            },
                            $scope
                        );
                    } else {
                        initDocgenre($scope.list);
                    }
                }

                /**
                 * [updateCKSelection description]更新稿费状态
                 * @param  {[obj]} list [description]稿件对象
                 * @return {[type]}     [description]
                 */
                $scope.updateCKSelection = function(list) {
                    list.ISNOPAYMENT = list.ISNOPAYMENT === '1' ? '0' : '1';
                };

                /**
                 * [initDocgenre description]初始化稿件体裁
                 * @return {[type]} [description]
                 */
                function initDocgenre(obj) {
                    iWoService.initData().then(function(data) {
                        $scope.data.docgenre = data.DocGenre;
                        $scope.list.DOCGENRE = obj.DOCGENRE ? obj.DOCGENRE : angular.copy($scope.data.docgenre[0]);
                    });
                }
            },
        };
    },
]);
